import { MapPin, Phone, Mail, Clock, ChevronRight } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HelpButton from "../components/HelpButton";
// import OfferteForm from '../components/OfferteForm';
import SEO from "../components/SEO";

const seoData = {
  title: "Contact - Elektrotechnische Installaties",
  description:
    "Neem contact op met ons voor vragen, offertes of om een afspraak te maken. Bel ons, stuur een e-mail of bezoek ons kantoor.",
  schema: {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: "Contact - Elektrotechnische Installaties",
    description:
      "Neem contact op voor al uw elektrotechnische vragen en afspraakverzoeken.",
    url: "https://example.com/contact",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      telephone: "+31 85 212 97 78",
      areaServed: "NL",
      availableLanguage: "Dutch",
    },
  },
};


function Contact() {
  return (
    <div className="min-h-screen bg-white page-transition pt-[99px] md:pt-[133px]">
      <SEO {...seoData} />
      <Header />

      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-20 pt-16 md:pt-24">
        <h1 className="font-bold text-black leading-[1.25] text-[40px] lg:text-[52px] mb-4 text-[28px] md:mb-5 md:text-[44px] text-[#17354A]">
          Contact
        </h1>
        <div className="text-black leading-[1.56] text-[16px] md:text-[18px] font-normal text-[#17354A] max-w-[720px] mb-12">
          Heeft u vragen of wilt u een afspraak maken? Neem dan contact met ons
          op via onderstaande mogelijkheden.
        </div>

        {/* Contact Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {/* Phone Card */}
          <div className="bg-white rounded-xl border border-[#E5E7EB] p-6 hover:border-[#17354A]/50 transition-colors duration-150">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-[#F8F9FB] flex items-center justify-center">
                <Phone className="w-5 h-5 text-[#17354A]" />
              </div>
              <h3 className="text-[18px] font-medium text-[#17354A]">
                Bel ons
              </h3>
            </div>
            <p className="text-[#17354A] mb-6">
              Direct contact met onze klantenservice voor al uw vragen.
            </p>
            <a
              href="tel:+31852129778"
              className="text-[#FFD100] hover:underline font-medium text-lg"
            >
              +31 85 212 97 78
            </a>
          </div>

          {/* Email Card */}
          <div className="bg-white rounded-xl border border-[#E5E7EB] p-6 hover:border-[#17354A]/50 transition-colors duration-150">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-[#F8F9FB] flex items-center justify-center">
                <Mail className="w-5 h-5 text-[#17354A]" />
              </div>
              <h3 className="text-[18px] font-medium text-[#17354A]">E-mail</h3>
            </div>
            <p className="text-[#17354A] mb-6">
              Stuur ons een e-mail, we reageren binnen 24 uur.
            </p>
            <a
              href="mailto:info@elektricieninarnhem026.nl"
              className="text-[#FFD100] hover:underline font-medium text-lg"
            >
              info@elektricieninarnhem026.nl
            </a>
          </div>

          {/* Address Card */}
          <div className="bg-white rounded-xl border border-[#E5E7EB] p-6 hover:border-[#17354A]/50 transition-colors duration-150">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-[#F8F9FB] flex items-center justify-center">
                <MapPin className="w-5 h-5 text-[#17354A]" />
              </div>
              <h3 className="text-[18px] font-medium text-[#17354A]">
                Bezoekadres
              </h3>
            </div>
            <p className="text-[#17354A] mb-6">
              Ons kantoor is op afspraak te bezoeken.
            </p>
            <address className="not-italic text-[#17354A] text-lg">
              Laan van vollenhove 2935
              <br /> 3706 AK Zeist
            </address>
          </div>
        </div>

        {/* Opening Hours */}
        <div className="bg-[#F8F9FB] rounded-xl p-8 mb-16">
          <div className="flex items-center gap-3 mb-6">
            <Clock className="w-6 h-6 text-[#17354A]" />
            <h2 className="text-[24px] font-bold text-[#17354A]">
              Openingstijden
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div>
              <h3 className="font-medium text-[#17354A] mb-2">
                Maandag t/m vrijdag
              </h3>
              <p className="text-[#17354A]">07:00 - 18:00</p>
            </div>
            <div>
              <h3 className="font-medium text-[#17354A] mb-2">Zaterdag</h3>
              <p className="text-[#17354A]">12:00 - 17:00</p>
            </div>
            <div>
              <h3 className="font-medium text-[#17354A] mb-2">Zondag</h3>
              <p className="text-[#17354A]">Gesloten</p>
            </div>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_400px] gap-12">
          <div className="bg-white rounded-xl border border-[#E5E7EB] p-8">
            <h2 className="text-[24px] font-bold text-[#17354A] mb-6">
              Stuur ons een bericht
            </h2>
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-[#17354A] mb-2">
                    Naam
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-3 rounded-lg border border-[#E5E7EB] focus:border-[#FFD100] focus:outline-none"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#17354A] mb-2">
                    E-mailadres
                  </label>
                  <input
                    type="email"
                    className="w-full px-4 py-3 rounded-lg border border-[#E5E7EB] focus:border-[#FFD100] focus:outline-none"
                    required
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-[#17354A] mb-2">
                  Onderwerp
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-3 rounded-lg border border-[#E5E7EB] focus:border-[#FFD100] focus:outline-none"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-[#17354A] mb-2">
                  Bericht
                </label>
                <textarea
                  rows={6}
                  className="w-full px-4 py-3 rounded-lg border border-[#E5E7EB] focus:border-[#FFD100] focus:outline-none resize-none"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] text-base px-6 h-12 bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80"
              >
                <span className="flex items-center gap-1">
                  Versturen
                  <ChevronRight className="w-4 h-4" />
                </span>
              </button>
            </form>
          </div>

          {/* Company Info */}
          <div className="space-y-8">
            <div>
              <h3 className="font-medium text-[#17354A] mb-2">KvK-nummer</h3>
              <p className="text-[#17354A]">93984707</p>
            </div>
            <div>
              <h3 className="font-medium text-[#17354A] mb-2">BTW-nummer</h3>
              <p className="text-[#17354A]">NL866593433B01</p>
            </div>
          </div>
        </div>
      </section>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Contact;
